/* oxlint-disable jsx-a11y/no-autofocus -- Dialog opens directly into the API key name field. */
import type { ChangeEvent } from 'react';

import { Field, FieldError, FieldLabel, Input } from 'design-system';

const keyNameErrorId = 'key-name-error';

type PreGenerationBodyProps = {
  apiKeyName: string;
  error: string;
  loading: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
};

const PreGenerationBody = ({ apiKeyName, error, loading, onChange }: PreGenerationBodyProps) => (
  <Field
    className='gap-1'
    data-invalid={error ? 'true' : undefined}
    data-disabled={loading ? 'true' : undefined}
  >
    <FieldLabel htmlFor='key-label'>Name</FieldLabel>
    <Input
      autoFocus
      autoComplete='off'
      aria-describedby={error ? keyNameErrorId : undefined}
      aria-invalid={error ? true : undefined}
      disabled={loading}
      id='key-label'
      maxLength={60}
      value={apiKeyName}
      onChange={onChange}
    />
    {error && (
      <FieldError
        id={keyNameErrorId}
        role='alert'
      >
        {error}
      </FieldError>
    )}
  </Field>
);

export default PreGenerationBody;
